import { useState } from "react";
import { Link } from "react-router-dom";
import { faqList } from "@/mocks/faq";

export default function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number>(0);

  return (
    <section className="bg-background-100/70 py-12 md:py-16" aria-labelledby="faq-title">
      <div className="container-site grid grid-cols-1 gap-8 lg:grid-cols-5">
        <div className="lg:col-span-2">
          <span className="chip-tag">阅读帮助</span>
          <h2 id="faq-title" className="mt-3 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
            常见问题
          </h2>
            <p className="mt-3 text-sm leading-relaxed text-foreground-600 md:text-base">
              关于免费阅读、更新节奏与大结局畅读的常见疑问，这里都有答案。如果还有其它问题，欢迎前往
              <Link to="/about" className="mx-1 text-primary-600 hover:text-primary-700">关于我们</Link>
              页面留言反馈。
            </p>
          <Link
            to="/about"
            className="mt-5 inline-flex items-center gap-1 text-sm font-medium text-primary-600 hover:text-primary-700 cursor-pointer"
          >
            联系我们<i className="ri-arrow-right-line" aria-hidden="true" />
          </Link>
        </div>

        <div className="lg:col-span-3">
          <div className="space-y-3">
            {faqList.map((faq, index) => {
              const open = openIndex === index;
              return (
                <div
                  key={faq.question}
                  className={`overflow-hidden rounded-lg border transition-colors ${
                    open ? "border-primary-300 bg-background-50" : "border-background-200/70 bg-background-50"
                  }`}
                >
                  <button
                    type="button"
                    onClick={() => setOpenIndex(open ? -1 : index)}
                    aria-expanded={open}
                    className="flex w-full items-center justify-between gap-3 px-4 py-3.5 text-left md:px-5 md:py-4 cursor-pointer"
                  >
                    <span className="flex items-center gap-2.5 text-sm font-semibold text-foreground-950 md:text-base">
                      <span className={`flex h-6 w-6 shrink-0 items-center justify-center rounded-full text-xs font-bold ${open ? "bg-primary-500 text-background-50" : "bg-secondary-100 text-secondary-800"}`}>
                        Q
                      </span>
                      {faq.question}
                    </span>
                    <i
                      className={`ri-add-line shrink-0 text-lg text-foreground-600 transition-transform duration-300 ${open ? "rotate-45" : ""}`}
                      aria-hidden="true"
                    />
                  </button>
                  {open && (
                    <div className="border-t border-background-200/70 px-4 py-3.5 md:px-5 md:py-4">
                      <p className="flex items-start gap-2.5 text-sm leading-relaxed text-foreground-700">
                        <span className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-accent-100 text-xs font-bold text-accent-800">
                          A
                        </span>
                        {faq.answer}
                      </p>
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}